angular.module('main').filter('timeFilter', [
	'$filter',
	'timeConverter',
	'settingsService',
	function($filter, timeConverter, settingsService) {
		let calendarSettingsDate, calendarSettingsHours;

		settingsService.timeFormatSettings.subscribe(data => {
			calendarSettingsDate = data.dateFormat === 'DD_MM_YYYY';
			calendarSettingsHours = data.timeFormat === 'T_12';
		});

		return function(input, type) {
			let output;

			if (!input) {
				return '';
			}
			switch (type) {
				case '12h':
					if (calendarSettingsHours) {
						output = timeConverter.convert24to12(input);
					} else {
						output = input.substring(0, 5);
					}
					break;
				case '12hL':
					if (calendarSettingsHours) {
						output = timeConverter.convert24to12(input).toLocaleLowerCase();
					} else {
						output = input.substring(0, 5);
					}
					break;
				case '12hLS':
					if (calendarSettingsHours) {
						output = timeConverter
							.convert24to12(input)
							.toLocaleLowerCase()
							.replace(' ', '');
					} else {
						output = input.substring(0, 5);
					}
					break;
				case 'long':
					if (calendarSettingsDate) {
						output = $filter('date')(input, 'dd MMMM yyyy');
					} else {
						output = $filter('date')(input, 'MMMM dd yyyy');
					}
					break;
				case 'medium':
					if (calendarSettingsDate) {
						output = $filter('date')(input, 'dd MMM yyyy');
					} else {
						output = $filter('date')(input, 'MMM dd yyyy');
					}
					break;
				case 'dayAndMonth':
					if (calendarSettingsDate) {
						output = $filter('date')(input, 'dd MMMM');
					} else {
						output = $filter('date')(input, 'MMMM dd');
					}
					break;
				default:
					output = '';
			}

			return output;
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/services/filters/timeFilter.js